import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { AccountScopes, ApiAccountResponse } from '../api';

// TODO: remove AccountInfo after moving to REST:
// useLoginViaDecryptedMessageMutation, useRegisterBeneficiaryByInvitationCodeMutation
type AccountInfo = {
  id: number;
  email: string;
  profile?: {
    userName: string;
  };
};

export type TenantOwner = {
  profileId: number;
  scopes: AccountScopes;
};

export type AuthStoreState = {
  legacyToken: string | null;
  account: ApiAccountResponse | AccountInfo | null;
  schemaVersion: number | null;
  accessToken: string | null;
  tenantOwners: TenantOwner[] | null;
};

type AuthStore = AuthStoreState & {
  setLegacyToken: (legacyToken: string | undefined) => void;
  setAccount: (account: ApiAccountResponse | AccountInfo | null) => void;
  setSchemaVersion: (schemaVersion: number) => void;
  clear: () => void;
  setAccessToken: (accessToken: string) => void;
  setTenantOwners: (tenantOwners: TenantOwner[]) => void;
};

const getInitialState = (): AuthStoreState => ({
  legacyToken: null,
  account: null,
  schemaVersion: null,
  accessToken: null,
  tenantOwners: null,
});

export const useAuthStore = create(
  persist<AuthStore>(
    (set) => ({
      ...getInitialState(),

      setAccessToken: (accessToken) => set({ accessToken }),
      setLegacyToken: (legacyToken) => set({ legacyToken }),
      setAccount: (account) => set({ account }),
      setSchemaVersion: (schemaVersion) => set({ schemaVersion }),
      clear: () => set({ ...getInitialState() }),
      setTenantOwners: (tenantOwners: TenantOwner[]) => set({ tenantOwners }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
